import { requestLocationData } from "../getData";
import logo from '../taghtia-btn-logo.png'
const ACTIVE = false ;
const FETCHING = true;
function PendingWidget({mapview,setStatus,controller,setLocation , pendingLocation , setPendingLocation ,pinLayer,setLocationCoords}){



    return(
        <div className="widget-pending slide-top">
        <button className="validate-btn" onClick={async ()=>{
            try{
                setStatus(FETCHING);
                let resp = await requestLocationData(pendingLocation,{signal:controller.signal});
                try{
                    mapview.current.goTo({
                        center:[pendingLocation.longitude,pendingLocation.latitude],
                    })
                }
                catch(e){
                    console.log(e);
                }
                setLocation(resp);
                setLocationCoords(pendingLocation);
                setPendingLocation(null);
                setStatus(ACTIVE);
            }catch(e){   
                setStatus(ACTIVE); 
            }
        }}><img src={logo}></img></button>
        <h1 style={{marginLeft:'10px'}}>Cliquez sur le bouton Taghtia pour afficher votre couverture</h1>
        <i className="fa-solid fa-xmark fa-xl exit" onClick={()=>{
                pinLayer.current.removeAll();
                controller.abort();
                setPendingLocation(null);
        }}></i>
        </div>
    )

}
export default PendingWidget;